export const showData = (params) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: `show data`,
      showPromo: {
        data: [
          {
            id: `${params?.id}`,
            name: `${params?.title?.toLowerCase() || 'Tidak Tersedia'}`,
            creative: `${params?.baseSlug}/${params?.category
              ?.replace(/ /g, '-')
              .toLowerCase()}/${params?.slug?.toLowerCase()}`,
            category: `${params?.category?.replace(/-/g, ' ').toLowerCase()}`,
          },
        ],
      },
    });
  }
};
